<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form
        @submit="EditeInventaire"
        :validation-schema="inventaireSchema"
        :keep-values="valuess">
          <div class="row">
            <div class="col-md-12 mb-3">
              <div class="form-group">
                <label class="d-block text-black fw-semibold mb-10">
                    Fiche d'inventaire
                </label>
                <Multiselect
                  :options="inventaireOptions"
                  :searchable="true"
                  track-by="label"
                  label="label"
                  v-model="inventaire"
                  placeholder="Sélectionner une fiche"
                  @select="selectInventaire(inventaire)"
                />
              </div>
            </div>
          <div class="col-md-12">
              <div class="border border-primary mb-10">
                <div class="d-flex align-items-center justify-content-between fw-bold py-2 bg-primary">
                  <div class="col-md-7">
                    <h4 class="fs-4 text-black px-2">{{ magasinss? magasinss:"Magasin" }}</h4>
                  </div>
                  <div class="col-md-5">
                    <div class="d-flex float-end">
                     
                    </div>
                  </div>
                </div>
                <div>
                  <div class="row gx-2 mt-10 p-2">
                    <div class="col-md-4">
                      <label
                        class="d-block text-black fw-semibold">
                        Produit
                        <span class="text-danger">*</span>
                      </label>
                    </div>
                    <div class="col-md-2">
                      <label  class="d-block text-black fw-semibold mb-10">Stock Ven
                      </label>
                    </div>
                    <div class="col-md-2">
                      <label
                        class="d-block text-black fw-semibold mb-10" >Quantité Avariée
                      </label>
                    </div>
                    <div class="col-md-1">
                      <label
                        class="d-block text-black fw-semibold mb-10" :readOnly="true">Ecart Fiche
                      </label>
                    </div>
                    <div class="col-md-1">
                      <label
                        class="d-block text-black fw-semibold mb-10" :readOnly="true">Ecart Logi
                      </label>
                    </div>
                    <div class="col-md-2">
                      <label
                        class="d-block text-black fw-semibold mb-10" :readOnly="true">Observation
                      </label>
                    </div>
                    <hr class="mt-0" />
                  </div>
                  <div class="row gx-2 px-2" v-for="(produit, produitIndex) in produits" :key="produitIndex">
                      <div class="col-md-4 mb-2">
                        <div class="form-group ">
                          <div class="input-group">
                            <span class="input-group-text list-light-primary">
                              <a class=""
                                href="javascript:void(0);"
                                 @click="detail(produit)">
                                <i class="icofont icofont-open-eye"></i>
                              </a>
                            </span>
                            <input class="form-control" 
                              type="text"
                              :readonly="true"
                              v-model="produit.nomProd"
                              :class="
                                validateRowProduit(produit.nomProd)
                                  ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                                  : 'form-control shadow-none fs-md-15 text-black '"
                                placeholder="Entrer la quantité"
                            >
                          </div>
                          <div class="invalid-feedback"
                            v-if="
                              validateRowProduit(produit.nomProd)" >
                              Le produit est obligatoire.
                          </div>
                        </div>
                      </div>
                      <div class="col-md-2 ">
                        <div class="form-group mb-2">
                          <input
                            v-model="produit.qtePhysique"
                            type="number"
                            :class="
                              validateRowProduit(produit.qtePhysique)
                                ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                                : 'form-control shadow-none fs-md-15 text-black '"
                            placeholder="Entrer la quantité"/>
                          <div
                            v-if="validateRowProduit(produit.qtePhysique)"
                            class="invalid-feedback">
                            La quantité est obligatoire.
                          </div>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group mb-2">
                          <input
                            v-model="produit.qteAvariee"
                            type="number" 
                            :class="
                              validateRowProduit(produit.qteAvariee)
                                ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                                : 'form-control shadow-none fs-md-15 text-black '"
                              placeholder="Quantité Avariée"
                          />
                          <div v-if="validateRowProduit(produit.qteAvariee)"
                            class="invalid-feedback">
                            La quantité est obligatoire.
                          </div>
                        </div>
                      </div>
                      <div class="col-md-1 mb-2">
                          <div class="form-group ">
                            <input
                              v-model="produit.ecartFiche"
                              :readonly="true"
                              type="number" 
                              :class="
                                validateRowProduit1(produit.ecartFiche)
                                  ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                                  : 'form-control shadow-none fs-md-15 text-black '"
                              placeholder="Entrer l'écart"
                            />
                            <div
                              v-if="validateRowProduit1(produit.ecartFiche)"
                              class="invalid-feedback" >
                              L'écart est obligatoire.
                            </div>
                          </div>
                    </div>
                    <div class="col-md-1">
                      <div class="form-group mb-2">
                        <input
                          v-model="produit.ecartLogique"
                          :readonly="true"
                          type="number" 
                          :class="
                            validateRowProduit1(produit.ecartLogique)
                              ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                              : 'form-control shadow-none fs-md-15 text-black '
                          "
                          placeholder="Entrer l'écart"/>
                        <div
                          v-if="validateRowProduit1(produit.ecartLogique)"
                          class="invalid-feedback">
                            L'écart est obligatoire.
                        </div>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group mb-2">
                        <input
                          v-model="produit.observation"
                          type="text" 
                          class="form-control shadow-none text-black "
                          placeholder="Observation"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
          <div class="col-md-12 mt-3">
            <div class="d-flex align-items-center">
              <button
                class="btn btn-success me-3"
                type="submit"
                :disabled="isDisable"
                :class="{ 'cursor-not-allowed': isDisable }">
                  Enregistrer
              </button>
              <button
                class="btn btn-primary text-black me-3" 
                type="button"
                :disabled="isDisable"
                @click="Soumettre()"
                :class="{ 'cursor-not-allowed': isDisable }">
                 Enregistrer et Soumettre
              </button>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
  <ModalDetailProdCondMagInv @openmodal="showModalEdite" v-if="element" :item="element" />
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted, reactive } from "vue";
import { Form, Field, ErrorMessage, useFieldArray } from "vee-validate";
import { error,showModal, success,format_date } from "@/utils/utils";
import ModalDetailProdCondMagInv from "./ModalDetailProdCondMagInv.vue";

import { useRoute, useRouter } from "vue-router";
import ApiService from "@/services/ApiService";
import {
  Inventaire,
} from "@/models/Inventaire";

import * as Yup from "yup";
import Multiselect from "@vueform/multiselect";
import Swal from "sweetalert2";

export default defineComponent({
  name: "AddInventaire",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
    ModalDetailProdCondMagInv
  },
  setup: () => {
    const inventaireSchema = Yup.object().shape({
    
    });

    const inventaireForm = ref<Inventaire | null>(null);
    const router = useRouter();
    const clientOptions = ref([]);
    const magasinOptions = ref([]);
    const produitOptions = ref([]);
    const personneOptions = ref([]);
    const magasin = ref();
    const route = useRoute();

    // formulaire dynamique start
    const isDisable = ref(true);
    const produits = reactive([]);
    const inventaireOptions = ref([]);
    const inventaire = ref("");


const calculEcart = (produit) => {
  console.log(produit,"produitproduitproduitproduit");
    produit.ecartLogique = produit.qtePhysique + produit.qteAvariee- produit.qteLogique;
    produit.ecartFiche = produit.qtePhysique + produit.qteAvariee - produit.qteFiche;
};

const Soumettre = async()=>{
      Swal.fire({
        text: "Vous êtes sur le point de soumettre l'inventaire. Etes-vous sûr ?",
        icon: "warning",
        buttonsStyling: true,
        showCancelButton: true,
        confirmButtonText: "Enregistrer et Soumettre",
        cancelButtonText: `Annuler`,
        heightAuto: false,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton:"btn btn-danger"
        },
      }).then(async(result) => {
        try {
            if (result.isConfirmed) {
              const values = {
              inventaiprocondimags:produits,
              statut:2
            }
            const response = await ApiService.put("/inventaires/"+inventaire.value, values)
            if (response.data.code == 200) {
              success(response.data.message);
              router.push({ name: "ListeInventaire" });
            }
          }else{
            error("Vous avez annulé la soumission");
          }
          
        } catch (response) {
          error(response.message);
        }
      })
}

function showModalEdite(model:any){
  showModal(model);
}
const fetchInventaire = async () => {
      try {
        const response = await ApiService.get("/inventaires/statut/1/Partiel");
        const invData = response.data.data;
        inventaireOptions.value = invData.map((inv) => ({
          value: inv.id,
          label: `${inv.refInventaire} [${format_date(inv.dateDebut)} - ${format_date(inv.dateFin)}]- ${inv.magasin.nomMagasin}`,
        }));
        console.log(inventaireOptions,"inventaireOptionsinventaireOptions")
      } catch (error) {
        //
      }
};

const product= ref<{id:"",qtePhysique:"",qteLogique: null, qteFiche: null,qteAvariee: null,ecartLogique: null,ecartReel:null,nomProd: "",observation: ""}>();

watch(
  () => produits,
  (newProduits) => {
    newProduits.forEach(produit => {
        calculEcart(produit);
    });
  },
  { deep: true }
);


const validateRowProduit = (e) => {
  return e === '' || e == null || e < 0;
};

const validateRowProduit1 = (e) => {
  return e === '' || e == null;
};

watch(
  produits,
  (newValue) => {
    isDisable.value = newValue.some((produit) =>
    produit.qteAvariee < 0 || 
    produit.qtePhysique < 0 || 
    produit.qtePhysique  === '');
  },
  { deep: true }
);


    onMounted(() => {
      fetchInventaire()
    });


    const valuess = ref();
    const magasinss = ref("");

    const getCurrentDateTime = () => {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, "0");
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const year = today.getFullYear();
      const hours = String(today.getHours()).padStart(2, "0");
      const minutes = String(today.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    const EditeInventaire = async () => {
      const values = {
        inventaiprocondimags:produits,
      }
      ApiService.put("/inventaires/"+inventaire.value, values)
        .then(({ data }) => {
          if (data.code == 200) {
            success(data.message);
            router.push({ name: "ListeInventaire" });
          }
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    };

    async function getAllInventaireById(id) {
     await  ApiService.get(`/inventaires/`+id)
          .then(({ data }) => {
            magasinss.value = data.data.magasin.nomMagasin;
            console.log(data.data.inventaiprocondimags,"data.data.inventaiprocondimags");
            data.data.inventaiprocondimags.forEach(produit => {
            produits.push({
              id: produit.id,
              qtePhysique: produit.qtePhysique,
              qteLogique: produit.qteLogique,
              qteFiche: produit.qteFiche,
              qteAvariee: produit.qteAvariee,
              ecartLogique: produit.ecartLogique,
              ecartFiche: produit.ecartFiche,
              nomProd: produit.nomProd,
              observation: produit.observation
            })});
          })
          .catch(({ response }) => {
            error(response.data.message)
        });
    }

    const element = ref<any | null>(null);

    const detail = (valeur: any) => {
      element.value = valeur;
    };

    const selectInventaire = (selectedMagasin) => {
      if(selectedMagasin) {
        produits.length = 0;
        getAllInventaireById(selectedMagasin);
      }
    };
    
    return {
      inventaireSchema,
      inventaireForm,
      validateRowProduit,
      validateRowProduit1,
      magasinss,
      showModalEdite,
      produits,
      valuess,
      clientOptions,
      magasinOptions,
      inventaireOptions,
      inventaire,
      magasin,
      product,
      Soumettre,
      detail,
      element,
      produitOptions,
      selectInventaire,
      isDisable,
      getCurrentDateTime,
      EditeInventaire,
      personneOptions,
    };
  },
});
</script>

<style scoped>
.cursor-not-allowed {
  cursor: not-allowed;
}
.marge-droite {
  margin-left: 87px;
}
.hr-longeur {
  width: 80%;
}
.bord1 {
  border: 1px solid #07a;
}
.fond {
  background-color: rgb(94, 191, 233);
}
</style>